import { useRef, useState } from "react";
import './home.css';
import Sec1 from '../components/sec1';
import Collage from "../components/collage";
import Sec3 from "../components/sec3";
import Navbar from "../components/Nasbar";
import Sec2 from "../components/sec2";
import Sec4 from "../components/sec4";
import Footer from "../components/footer";

function Home() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggleMusic = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setPlaying(!playing);
  };

  return (
    <>
   <audio ref={audioRef} src="/music/the_mountain-history-documentary-167616.mp3" loop />

      <button onClick={toggleMusic} className="music-btn">
        {playing ? "⏸ MUTE" : "♪ SOUND ON"}
      </button>
        <Navbar />
      <Sec1 />
      <Sec2 />
      <Collage />
      <Sec3 />
      <Sec4 />
      <Footer />
      
    </>
  );
}

export default Home;